import PropTypes from 'prop-types';
import React, { Component } from 'react';
import VerticalEmbedInsertModal from './VerticalEmbedInsertModal.js';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-ui-components';
import '../constants.js';
import 'ricos-schema';
import '../ItemsList-09cdb7f4.js';
import '../style-inject.es-746bb8ed.js';
import 'classnames';
import './itemsList/Item.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../convertDuration.js';
import 'lodash';
import '../types.js';
import 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VerticalEmbedInputModal extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "onConfirm", (data) => {
      const { onConfirm, helpers, onReplace } = this.props;
      const addFunc = onConfirm || onReplace;
      addFunc(data);
      helpers.closeModal();
    });
    __publicField(this, "onCloseRequested", () => {
      var _a;
      (_a = this.props.helpers) == null ? void 0 : _a.closeModal();
    });
  }
  render() {
    const { t, componentData, helpers, isMobile, experiments, verticalsApi, locale } = this.props;
    return /* @__PURE__ */ React.createElement(
      VerticalEmbedInsertModal,
      {
        componentData,
        t,
        isMobile,
        verticalsApi,
        locale,
        experiments,
        helpers,
        onCloseRequested: this.onCloseRequested,
        onConfirm: this.onConfirm
      }
    );
  }
}
VerticalEmbedInputModal.propTypes = {
  onConfirm: PropTypes.func,
  onReplace: PropTypes.func,
  helpers: PropTypes.object.isRequired,
  componentData: PropTypes.object.isRequired,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  verticalsApi: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  experiments: PropTypes.object
};

export { VerticalEmbedInputModal as default };
//# sourceMappingURL=VerticalEmbedInputModal.js.map
